import { NgIf, CommonModule } from '@angular/common';
import { ɵɵelementContainerStart, ɵɵelementStart, ɵɵelement, ɵɵelementEnd, ɵɵelementContainerEnd, ɵɵnextContext, ɵɵadvance, ɵɵstyleMap, ɵɵproperty, ɵɵsanitizeUrl, ɵɵpipe, ɵɵpropertyInterpolate, ɵɵclassMap, ɵɵpipeBind1, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵNgOnChangesFeature, ɵɵtemplate, ɵsetClassMetadata, Component, Inject, Input, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { FileTypeIcoPipe, BaseUICommonModule } from 'baseuicommon';
import { UploadTypeEnum, FileUploadModule } from 'guploadmgr';
import { map } from 'rxjs/operators';
import { ISSUE_IMAGE_BASE_DIR_TOKEN } from 'solar-bo';
import { HttpClient } from '@angular/common/http';

function UIFileComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 1);
    ɵɵelementStart(2, "div", 2);
    ɵɵelement(3, "img", 3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵstyleMap(ctx_r0.outsideWrapper_style);
    ɵɵadvance(2);
    ɵɵproperty("src", ctx_r0.imagesrc, ɵɵsanitizeUrl);
} }
function UIFileComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "a", 4);
    ɵɵelement(2, "i");
    ɵɵpipe(3, "filetypeico");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵpropertyInterpolate("href", ctx_r1.imagesrc, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵclassMap(ɵɵpipeBind1(3, 4, ctx_r1.filedata.name));
} }
class UIFileComponent {
    constructor(http, config) {
        this.http = http;
        this.width = 160;
        this.height = 128;
        this.outsideWrapper_style = "width:160px;height:128px;";
        this.showimage = false;
        this.showFile = false;
        /**
         * base dir for url images
         */
        this.issueimagebasedir = '';
        this.issueimagebasedir = config.baseUrl;
    }
    ngOnInit() {
        this.outsideWrapper_style = "width:" + this.width + "px;height:" + this.height + "px;";
    }
    ngOnChanges(changes) {
        //console.log("UIFileComponent ngOnChanges " ,changes);
        const typeChange = changes['filedata'];
        if (typeChange && typeChange.currentValue) {
            if (this.filedata.upload_type == UploadTypeEnum.flight_rgb) {
                this.imagesrc = this.urlImgByFileData(this.filedata);
                this.showimage = true;
            }
            else if (this.filedata.upload_type == UploadTypeEnum.flight_thermal_rjpeg) {
                this.imagesrc = this.urlImgByFileThermal(this.filedata);
                this.showimage = true;
            }
            else if (this.filedata.upload_type == UploadTypeEnum.site_info) {
                this.imagesrc = this.siteFileUrlBy(this.filedata.name, this.filedata.id_resource);
                this.showimage = false;
                this.showFile = true;
                //this.test();
            }
            else {
                this.showimage = false;
            }
        }
    }
    ngAfterViewInit() {
    }
    urlImgByFileData(fileData) {
        let u = `/images-supervision/${fileData.id_site}/supervisions/${fileData.id_supervision}/input/rgb/${fileData.id_resource}/${fileData.name}`;
        u = this.issueimagebasedir + u;
        return u;
    }
    urlImgByFileThermal(fileData) {
        let u = `/images-supervision/${fileData.id_site}/supervisions/${fileData.id_supervision}/input/thermal/RJPEG/${fileData.id_resource}/${fileData.name}`;
        u = this.issueimagebasedir + u;
        return u;
    }
    urlImgByFullFields(imagename, id_site, id_supervision, id_flight) {
        let u = `/images-supervision/${id_site}/supervisions/${id_supervision}/input/rgb/${id_flight}/${imagename}`;
        u = this.issueimagebasedir + u;
        return u;
    }
    siteFileUrlBy(filename, id_site) {
        let u = `/images-supervision/${id_site}/reference/${filename}`;
        u = this.issueimagebasedir + u;
        return u;
    }
    test() {
        this.getImage().subscribe(response => console.log(response));
    }
    getImage() {
        return this.http
            .get("https://prepro.geoaitech.com/images-supervision/3e23a072-581a-11ea-a413-509a4c837ab7/reference/Pinus.pdf", {
            responseType: "arraybuffer"
        })
            .pipe(map(response => {
            return new File([response], "myImage.png");
        }));
    }
}
UIFileComponent.ɵfac = function UIFileComponent_Factory(t) { return new (t || UIFileComponent)(ɵɵdirectiveInject(HttpClient), ɵɵdirectiveInject(ISSUE_IMAGE_BASE_DIR_TOKEN)); };
UIFileComponent.ɵcmp = ɵɵdefineComponent({ type: UIFileComponent, selectors: [["app-uifile"]], inputs: { filedata: "filedata", imagesrc: "imagesrc", width: "width", height: "height" }, features: [ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "outsideWrapper"], [1, "insideWrapper"], [1, "issue-image", "coveredImage", 3, "src"], ["target", "_blank", 3, "href"]], template: function UIFileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, UIFileComponent_ng_container_0_Template, 4, 3, "ng-container", 0);
        ɵɵtemplate(1, UIFileComponent_ng_container_1_Template, 4, 6, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.showimage);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showFile);
    } }, directives: [NgIf], pipes: [FileTypeIcoPipe], styles: [".outsideWrapper[_ngcontent-%COMP%]{height:128px;margin:0;width:160px}.insideWrapper[_ngcontent-%COMP%]{height:100%;position:relative;width:100%}.coveredImage[_ngcontent-%COMP%], .coveringCanvas[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UIFileComponent, [{
        type: Component,
        args: [{
                selector: 'app-uifile',
                templateUrl: './uifile.component.html',
                styleUrls: ['./uifile.component.scss']
            }]
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [ISSUE_IMAGE_BASE_DIR_TOKEN]
            }] }]; }, { filedata: [{
            type: Input
        }], imagesrc: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }] }); })();

class UiFileComponentsModule {
}
UiFileComponentsModule.ɵmod = ɵɵdefineNgModule({ type: UiFileComponentsModule });
UiFileComponentsModule.ɵinj = ɵɵdefineInjector({ factory: function UiFileComponentsModule_Factory(t) { return new (t || UiFileComponentsModule)(); }, imports: [[
            CommonModule,
            BaseUICommonModule,
            FileUploadModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(UiFileComponentsModule, { declarations: [UIFileComponent], imports: [CommonModule,
        BaseUICommonModule,
        FileUploadModule], exports: [UIFileComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(UiFileComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BaseUICommonModule,
                    FileUploadModule
                ],
                declarations: [UIFileComponent],
                exports: [UIFileComponent]
            }]
    }], null, null); })();

class SolarComponentsModule {
}
SolarComponentsModule.ɵmod = ɵɵdefineNgModule({ type: SolarComponentsModule });
SolarComponentsModule.ɵinj = ɵɵdefineInjector({ factory: function SolarComponentsModule_Factory(t) { return new (t || SolarComponentsModule)(); }, imports: [[
            CommonModule,
            BaseUICommonModule,
            UiFileComponentsModule
        ], UiFileComponentsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SolarComponentsModule, { imports: [CommonModule,
        BaseUICommonModule,
        UiFileComponentsModule], exports: [UiFileComponentsModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SolarComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BaseUICommonModule,
                    UiFileComponentsModule
                ],
                declarations: [],
                exports: [UiFileComponentsModule]
            }]
    }], null, null); })();

/*
 * Public API Surface of solar-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SolarComponentsModule, UIFileComponent, UiFileComponentsModule };
//# sourceMappingURL=solar-components.js.map
